import { CharacterListResponse } from '../api/types/chat';
import { ScenarioCharacter } from '../api/types/scenario';

/**
 * Filters out characters that are already in the active scenario or in the available characters list
 * @param searchResults - The list of characters to filter
 * @param existingCharacters - The list of characters already in the active scenario (optional)
 * @param availableCharacters - The list of characters already in the available characters list
 * @returns Filtered list of characters
 */
export const filterAvailableCharacters = (
  searchResults: CharacterListResponse[],
  existingCharacters: ScenarioCharacter[] = [],
  availableCharacters: ScenarioCharacter[] = []
): CharacterListResponse[] => {
  return searchResults.filter(character => 
    !existingCharacters.some(char => char.id === character.id) && 
    !availableCharacters.some(availableChar => availableChar.id === character.id)
  );
}; 